module.exports = __webpack_public_path__ + "img/tmall-douyin.63562e74.png";